import { getResourceObject } from "./values";

export const landingPageUrl =
  process.env.REACT_APP_LANDING_URL || "https://stage.kulpacloud.com";

export const externalRoutes = {
  googlePlay: "https://play.google.com/store/apps/details?id=io.kulpa.kulpa",
  appStore: "https://itunes.apple.com/app/id1516538458",
  faq: `${landingPageUrl}/faqs`,
  victimSupport: `${landingPageUrl}/victimSupport`,
  helpVideos: `${landingPageUrl}/howtocapture`,
  contact: `${landingPageUrl}/contactSupport`,
  terms: userType =>
    `${landingPageUrl}/termsAndConditions/${userType}#termsAndConditions`,
  privacy: userType =>
    `${landingPageUrl}/termsAndConditions/${userType}#policies`,
  kpcc: "https://police.kulpacloud.com/"
};

export const urls = {
  login: "/login",
  logout: "/logout",
  settings: "/settings",
  cases: "/cases",
  createCase: "/cases/new",
  caseDetail: "/cases/:caseId",
  notFound: "/404",

  // Case Options
  statements: "/cases/:caseId/statements",
  caseStatementDetail: "/cases/:caseId/statements/:itemId",
  statement: "/cases/:caseId/statements/:itemId/form",
  sai: "/cases/:caseId/interview",
  saiDetail: "/cases/:caseId/interview/:itemId",
  saiForm: "/cases/:caseId/interview/:itemId/form",
  caseLog: "/cases/:caseId/logs",
  caseDownload: "/cases/:caseId/download",
  caseMedia: "/cases/:caseId/media",
  caseMediaDetail: "/cases/:caseId/media/:itemId",
  incident: "/cases/:caseId/incident",
  incidentGallery: "/cases/:caseId/incident/:itemId",
  submitIncident: "/cases/:caseId/submitIncident",
  shareWith: "/cases/:caseId/share",
  medicalRecords: "/cases/:caseId/records",
  medicalRecordDetail: "/cases/:caseId/records/:itemId?",
  infoRequests: "/cases/:caseId/infoRequests",
  infoRequestDetail: "/cases/:caseId/infoRequests/:infoRequestId",
  inviteContributor: "/cases/:caseId/invite",
  contributorDetail: "/cases/:caseId/contributor/:contributorId",

  // Notes
  caseNotes: "/cases/:caseId/notes",
  newNote: "/cases/:caseId/notes/new",
  newStatement: "/cases/:caseId/notes/newStatement",
  draftNotes: "/cases/:caseId/notes/draft",
  noteDetail: "/cases/:caseId/notes/draft/:itemId",
  editNote: "/cases/:caseId/notes/edit/:itemId",
  publishedNotes: "/cases/:caseId/notes/published",
  statementDetail: "/cases/:caseId/notes/published/:itemId",

  // Download Report
  downloadReport: "/downloadReport/:reportId",

  // Injury
  addInjury: "/cases/:caseId/injury/new",
  editInjury: "/cases/:caseId/injury/:injuryId/edit",
  annotationTool: "/cases/:caseId/injury/:injuryId/:imgIndex",
  injuryDetail: "/cases/:caseId/injury/:injuryId",

  // Physical Damage
  addPhysicalDamage: "/cases/:caseId/physicalDamage/new",
  editPhysicalDamage: "/cases/:caseId/physicalDamage/:physicalDamageId/edit",
  physicalDamageAnnotationTool:
    "/cases/:caseId/physicalDamage/:physicalDamageId/:imgIndex",
  physicalDamageDetail: "/cases/:caseId/physicalDamage/:physicalDamageId",

  // AppStore
  downloadApp: "/download"
};

// Internal Routes
export const getRoute = (url, values) => {
  if (!url) return "";

  const mapValues = values && {
    ":caseId": values.caseId,
    ":injuryId": values.injuryId,
    ":physicalDamageId": values.physicalDamageId,
    ":imgIndex": values.index,
    ":infoRequestId": values.infoRequestId,
    ":contributorId": values.contributorId,
    ":reportId": values.reportId,
    ":itemId": values.itemId,
    ":itemId?": values.itemId
  };
  const path = url.replace(
    /:caseId|:injuryId|:physicalDamageId|:imgIndex|:infoRequestId|:contributorId|:reportId|:itemId\??/gi,
    // ?? not || - imgIndex can legitimately be 0, a falsy value that || would
    // wrongly treat as "no value given" and substitute with an empty string.
    matched => mapValues[matched] ?? ""
  );

  return `${path}${(values && values.query) || ""}`;
};

const mapResources = {
  injuries: urls.injuryDetail,
  media: urls.caseMedia,
  medicalRecords: urls.medicalRecords
};

export const getResourceRoute = resId => {
  const routeKey = Object.keys(mapResources).find(e => resId.includes(e));
  const resObject = getResourceObject(resId);

  return getRoute(mapResources[routeKey], resObject);
};
